import { render, staticRenderFns } from "./TrainingPlanPage.vue?vue&type=template&id=f9cc3b88&"
import script from "./TrainingPlanPage.vue?vue&type=script&lang=js&"
export * from "./TrainingPlanPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports